"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportStatus = void 0;
var ExportStatus;
(function (ExportStatus) {
    /** All new expenses after switchDaySetting will get this status */
    ExportStatus["NOT_EXPORTED"] = "NOT_EXPORTED";
    /** Expense put in ready for export queue */
    ExportStatus["QUEUED"] = "QUEUED";
    /** Expenses that are getting exported */
    ExportStatus["EXPORTING"] = "EXPORTING";
    /** Expenses that have been exported */
    ExportStatus["EXPORTED"] = "EXPORTED";
})(ExportStatus = exports.ExportStatus || (exports.ExportStatus = {}));
//# sourceMappingURL=export-status.js.map